'use client';

import { useState, useContext, useEffect, useMemo } from 'react';
import Alert from '@mui/material/Alert';
import { useNavigate, useLocation } from 'react-router-dom';
import DataContext from '@/contexts/DataContext';
import { useComponentLogger } from '@/lib/component-logger';

import { Page as Home } from '@/pages/dashboard/home';
import { Page as View } from '@/pages/dashboard/view';
import { Page as Loading } from '@/pages/dashboard/loading';

import { Box } from '@mui/system';
import { CircularProgress } from '@mui/material';

/**
 * Checks if route params are valid
 * If invalid, redirect back up the tree to the last valid param
 * If params only contian proj, redirects to the home page with the project selected
 * If they contain proj, app (optional), view, redirect to the view page
 * @param {*} param0 
 * @returns 
 */
export function RootRedirect({ children }) {
  const logger = useComponentLogger("Root Redirect")
  const navigate = useNavigate();
//   const { user, error, isLoading } = useUser();
  const [isChecking, setIsChecking] = useState(true);
  const [nextPage, setNextPage] = useState("loading");
  const requestedURL = JSON.parse(localStorage.getItem("requestedURL"));

  const location = useLocation();

  const checkParams = async () => {
    // const paramString = requestedURL?.search;
    const paramString = location.search;
    // logger.debug('param check', requestedURL, paramString);
    if (!paramString) {
      setNextPage("home");
      setIsChecking(false);
      return;
    }

    // if (paramString?.includes("proj")) {
    //   if ((paramString?.includes("appID") && paramString?.includes("viewID")) || paramString?.includes("viewID")) {
    //     setNextPage("view");
    //   } else setNextPage("home");
    // } else setNextPage("home");

    if (paramString.includes("proj") && paramString.includes("viewID") ) {
      setNextPage("view");
    } else {
      setNextPage("home");
    }

    setIsChecking(false);
  }

    useEffect(() => {
      checkParams().then(res => {
      })
    }, [requestedURL.search])

    logger.debug('next pg', nextPage)

    return (
      <Box>
      {/* {nextPage === "home" ? <Home/> : <View/>} */}
      {nextPage === "loading" ? (
                  <Loading />
                )
                : nextPage  === "home" ? <Home/> : <View/>
      }
      </Box>
    );
      
}
